import { Controller } from "@hotwired/stimulus"
import { track } from "../lib/mixpanel"

export default class extends Controller {
  static targets = ["amount", "submitBtn", "errors"]
  static values = { updateUrl: String }

  async save() {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    const raw = this.amountTarget.value.trim().replace(/[^0-9.]/g, "")
    const amount = parseFloat(raw)

    if (!raw || isNaN(amount) || amount <= 0) {
      this._showErrors(["Enter an amount greater than 0."])
      return
    }

    this._hideErrors()
    this.submitBtnTarget.disabled = true
    this.submitBtnTarget.textContent = "Saving..."

    try {
      const response = await fetch(this.updateUrlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": csrfToken
        },
        body: JSON.stringify({
          project: {
            liquidation_damages_flag: 1,
            liquidation_damages: amount
          }
        })
      })

      const data = await response.json()

      if (response.ok && data.success) {
        const display = document.querySelector("[data-field='liquidation-damages-amount']")
        if (display) display.textContent = `$${amount.toFixed(2)}`

        track("Liquidated Damages Updated", { amount })

        this._closeModal()
        this._showFlash("Liquidated damages updated successfully.")
      } else {
        this._showErrors(data.errors || ["Update failed"])
      }
    } catch {
      this._showErrors(["A network error occurred. Please try again."])
    } finally {
      this.submitBtnTarget.disabled = false
      this.submitBtnTarget.textContent = "Save Changes"
    }
  }

  _showErrors(messages) {
    if (!this.hasErrorsTarget) return
    this.errorsTarget.innerHTML = messages.map(m => `<p>${m}</p>`).join("")
    this.errorsTarget.classList.remove("hidden")
  }

  _hideErrors() {
    if (!this.hasErrorsTarget) return
    this.errorsTarget.classList.add("hidden")
    this.errorsTarget.innerHTML = ""
  }

  _closeModal() {
    this.element.classList.add("hidden")
    document.body.style.overflow = ""
  }

  _showFlash(message) {
    const container = document.createElement("div")
    container.className = "flash-toast-notice"
    container.dataset.controller = "flash"
    container.dataset.flashDismissAfterValue = "5000"
    container.setAttribute("role", "alert")

    const iconDiv = document.createElement("div")
    iconDiv.className = "shrink-0"
    iconDiv.innerHTML = `<svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>`

    const msgEl = document.createElement("p")
    msgEl.className = "flex-1 text-sm"
    msgEl.textContent = message

    container.appendChild(iconDiv)
    container.appendChild(msgEl)
    document.body.insertBefore(container, document.body.firstChild)
  }
}
